import { type ComponentType, type ReactElement } from 'react';
import { InfoTooltip } from '@/Components/Feedback';

interface Props {
    icon?: ComponentType<{ className?: string }>;
    label: string;
    description?: string;
}

export function LabelContent({ icon: Icon, label, description }: Props): ReactElement {
    return (
        <>
            {Icon && <Icon className="h-3.5 w-3.5" />}
            {label}
            {description && <InfoTooltip content={description} />}
        </>
    );
}
